import React, { FC } from "react";

interface ResetModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ResetModal: FC<ResetModalProps> = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-opacity-50 tw-z-50">
      <div className="tw-bg-white tw-rounded-xl tw-shadow-lg tw-w-100 tw-p-4">
        <h2 className="tw-text-lg tw-font-bold tw-mb-4">Reset Data</h2>
        <p className="tw-text-sm tw-text-black tw-mb-6">Are you sure you want to reset this test report.</p>
        <div className="tw-flex tw-justify-end tw-space-x-4">
          <button
            className="tw-px-4 tw-py-2 tw-bg-gray-300 tw-text-black tw-rounded tw-hover:bg-gray-400"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="tw-px-4 tw-py-2 tw-bg-[#FF7B6D] tw-text-white tw-rounded tw-font-bold tw-cursor-pointer tw-hover:bg-red-700"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetModal;
